export default "__VITE_ASSET__BO_eA90k__"